import { useMemo } from "react";
import { Cell, Column, Row } from "@silevis/reactgrid";
import { Styles } from "./style";
import { HEIGHT_HEADER_GROUP } from "../utils";
interface IProps {
  columns: Column[];
  groupHeaderRow: Row<Cell>;
  stickyLeftColumns?: number;
}
type HeaderCellGroup = Cell & {
  columnId: string;
  colspan: number;
  text?: string;
};
const HeaderGroup = (props: IProps) => {
  const { groupHeaderRow, stickyLeftColumns = 0 } = props;
  function handleGroupByColspan(headers: HeaderCellGroup[]) {
    const result = [];
    const columnObj = props.columns.reduce((acc, current) => {
      acc[current.columnId] = current;
      return acc;
    }, {} as Record<string, Column>);

    let i = 0;

    while (i < headers.length) {
      const h = headers[i] as HeaderCellGroup;
      const startIndex = i;

      if (h.colspan > 1) {
        const children = headers.slice(i, i + h.colspan);
        result.push({
          id: h.columnId,
          title: h.text,
          width: children.reduce(
            (acc, current) => acc + (columnObj[current.columnId]?.width || 0),
            0,
          ),
          columns: children.map((c: any) => c.columnId),
          startIndex,
        });
        i += h.colspan;
      } else {
        result.push({
          id: h.columnId,
          title: h.text || "",
          columns: [h.columnId],
          width: columnObj[h.columnId]?.width || 0,
          startIndex,
        });
        i++;
      }
    }

    return result;
  }

  const groupByColspan = useMemo(() => {
    if (!(groupHeaderRow as any)?.cells) return null;
    return handleGroupByColspan((groupHeaderRow as any).cells);
  }, [groupHeaderRow, props.columns]);

  let stickyLeftOffset = 0;

  return (
    <Styles className="custom-header-group">
      {groupByColspan?.map((colGroup) => {
        const isSticky = colGroup.startIndex < stickyLeftColumns;
        const left = stickyLeftOffset;
        if (isSticky) {
          stickyLeftOffset += colGroup.width;
        }

        return (
          <div
            className={`cell-item${isSticky ? " cell-item-sticky" : ""}`}
            style={{
              width: colGroup.width,
              height: HEIGHT_HEADER_GROUP,
              ...(isSticky ? { position: "sticky", left, zIndex: 11 } : {}),
            }}
            key={colGroup.id}
          >
            {colGroup.title}
          </div>
        );
      })}
    </Styles>
  );
};

export default HeaderGroup;
